import { ReactNode } from 'react';
import { isMobile } from 'react-device-detect';

import { theme } from 'shared/styles/theme';
import { definitions } from 'shared/types/APISchema';
import { Box } from 'shared/ui/Box';
import { Checkbox } from 'shared/ui/Checkbox/Checkbox';
import { Icon } from 'shared/ui/Icon';
import { Popover } from 'shared/ui/Popover/Popover';
import { Spinner } from 'shared/ui/Spinner';
import { Flex } from 'shared/ui/StyledComponents';

import { factory } from '../model/model';

type Props = {
  item: definitions['MinEmployeeTodoTask'];
  isCompleted?: boolean;
  isLoading?: boolean;
  children: ReactNode;
};

export const TodoListItem = ({ item, isCompleted, isLoading, children }: Props) => {
  const model = factory.useModel();

  return (
    <Flex
      backgroundColor={!isCompleted ? '' : theme.colors.gray300}
      padding={!isCompleted ? 0 : 15}
      borderRadius={!isCompleted ? 0 : theme.borderRadius}
      position='relative'
    >
      <Flex gap={10} alignItems={isMobile ? '' : 'center'}>
        {isLoading ? (
          <Spinner />
        ) : (
          !isCompleted &&
          !item?.isAutomatic && (
            <Checkbox
              onChange={() => model.completeTask({ task_id: item?.id.toString() })}
              checked={item?.completed}
              alignItems={isMobile ? '' : 'center'}
            />
          )
        )}
        {item?.isAutomatic && !isCompleted && (
          <Popover text='Эта задача закроется автоматически' bottom='20px' left='20px'>
            <Checkbox onChange={() => null} checked={item?.completed} disabled />
          </Popover>
        )}
        {isCompleted && (
          <Box width={24} height={24}>
            <Popover text='Эта задача уже закрыта' bottom='30px' left='30px'>
              <Flex
                borderRadius={8}
                backgroundColor={theme.colors.black}
                width={24}
                height={24}
                alignItems='center'
                justifyContent='center'
                minWidth={24}
              >
                <Icon name='accept' width={16} height={16} color='white' />
              </Flex>
            </Popover>
          </Box>
        )}
        <Box>{children}</Box>
      </Flex>
    </Flex>
  );
};
